@if (mainCategories$ | async; as mainCategories) {
    <div id="main-navigation" class="main-navigation">
        @if (navigationNode$ | async; as navigationNode) {
            @if (navigationNode.children?.length > 0) {
                @for (child of navigationNode.children; track child) {
                    @for (childnode of child.children; track childnode) {
                        @if (nodeVisible(childnode)) {
                            <nav #navChildren>
                                <a
                                    [attr.aria-expanded]="navigationOpened"
                                    [attr.aria-controls]="'wrapper_' + childnode.uid"
                                    [tabIndex]="0"
                                    role="button"
                                    [attr.aria-label]="childnode.title"
                                    id="{{ childnode.uid }}"
                                    aimoClickOutside
                                    (clickOutsideEvent)="clickout(navChildren)"
                                    class="main-title d-lg-block d-none"
                                    (click)="openNavigationUI(navChildren)">
                                    {{ childnode.title }}
                                </a>
                                <a
                                    [attr.aria-expanded]="navigationOpened"
                                    [attr.aria-controls]="'wrapper_' + childnode.uid"
                                    id="mobile-{{ childnode.uid }}"
                                    [tabIndex]="0"
                                    role="button"
                                    [attr.aria-label]="childnode.title"
                                    #mainTitle
                                    class="main-title main-title-mobile d-block d-lg-none"
                                    (click)="hideShowMainTitle(mainTitle, navChildren)">
                                    <i class="aimo-icon icon-petrol-blue icon-caret-left"></i>
                                    {{ childnode.title }}
                                    <i class="aimo-icon icon-petrol-blue icon-caret-right"></i>
                                </a>
                                <a
                                    id="{{ lastSelectedCategoryName }}"
                                    #categoryTitle
                                    class="main-title d-none d-lg-none"
                                    (click)="hideShowChildCategory(categoryTitle, mainTitle, navChildren)">
                                    <i class="aimo-icon icon-petrol-blue icon-caret-left"></i>
                                    {{ lastSelectedCategoryName }}
                                    <i class="aimo-icon icon-petrol-blue icon-caret-right"></i>
                                </a>
                                @if (childnode.children?.length > 0) {
                                    <div
                                        [id]="'wrapper_' + childnode.uid"
                                        class="wrapper"
                                        [ngClass]="
                                childnode.uid && childnode.uid === 'ProductsNavNode'
                                    ? 'wrapper-products wrapper-md'
                                    : 'wrapper-sm'
                            ">
                                        @if (childnode.uid && childnode.uid === 'ProductsNavNode') {
                                            <div class="main-categories">
                                                <aimo-cx-navigation-ui [node]="childnode"></aimo-cx-navigation-ui>
                                                <ul>
                                                    @for (mainCat of mainCategories.subcategories; track mainCat) {
                                                        <li
                                                            [ngClass]="{ active: lastSelectedCategory === mainCat.id }"
                                                            (mouseover)="
                                                toggleChildCategory(
                                                    mainCat.id,
                                                    mainCat.name,
                                                    mainCat.totalNumber,
                                                    mainCat.url,
                                                    categoryTitle,
                                                    mainTitle,
                                                    navChildren,
                                                    $event,
                                                    true
                                                )
                                            ">
                                                            <a
                                                                [attr.aria-expanded]="lastSelectedCategory === mainCat.id"
                                                                [attr.aria-controls]="'child_categories'"
                                                                [tabIndex]="0"
                                                                role="button"
                                                                [attr.aria-label]="mainCat.name + ' ' + mainCat.totalNumber"
                                                                class="category"
                                                                (click)="closeIfClickedTheSameLink(mainCat.url)"
                                                                [routerLink]="mainCat.url">
                                                                {{ mainCat.name }}
                                                                <span class="amount">{{ mainCat.totalNumber }}</span>
                                                            </a>
                                                            <a
                                                                [attr.aria-expanded]="lastSelectedCategory === mainCat.id"
                                                                [attr.aria-controls]="'child_categories'"
                                                                [tabIndex]="0"
                                                                role="button"
                                                                [attr.aria-label]=""
                                                                class="btn-link pl-2"
                                                                (click)="
                                                    toggleChildCategory(
                                                        mainCat.id,
                                                        mainCat.name,
                                                        mainCat.totalNumber,
                                                        mainCat.url,
                                                        categoryTitle,
                                                        mainTitle,
                                                        navChildren,
                                                        $event,
                                                         false
                                                    )
                                                ">
                                                                <i class="aimo-icon icon-inline icon-caret-right"></i>
                                                            </a>
                                                        </li>
                                                    }
                                                    <li (mouseover)="clearSelection()">
                                                        <a
                                                            [tabIndex]="0"
                                                            role="button"
                                                            [attr.aria-expanded]="lastSelectedCategory === '0'"
                                                            [attr.aria-controls]="'child_categories'"
                                                            [attr.aria-label]="'aimo.product.categoryRoot'|cxTranslate "
                                                            class="category-root"
                                                            (click)="closeIfClickedTheSameLink('/category/0')"
                                                            [routerLink]="'/category/0'">
                                                            {{ 'aimo.product.categoryRoot'|cxTranslate }}
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                            @if (childCategories$ | async; as childCategories) {
                                                <div
                                                    class="child-categories"
                                                    [id]="'child_categories'"
                                                >
                                                    <ul>
                                                        <li>
                                                            <a
                                                                [tabIndex]="0"
                                                                role="button"
                                                                [attr.aria-label]="
                                                    ('aimo.product.allCategories' | cxTranslate) +
                                                    ' ' +
                                                    lastSelectedCategoryName?.toLowerCase() +
                                                    ' ' +
                                                    lastSelectedCategoryTotal
                                                "
                                                                class="category category-all"
                                                                (click)="closeIfClickedTheSameLink(lastSelectedCategoryUrl)"
                                                                [routerLink]="lastSelectedCategoryUrl">
                                                                {{
                                                                    ('aimo.product.allCategories' | cxTranslate) +
                                                                    ' ' +
                                                                    lastSelectedCategoryName?.toLowerCase()
                                                                }}
                                                                <span
                                                                    class="amount">{{ lastSelectedCategoryTotal }}</span>
                                                            </a>
                                                        </li>
                                                        <ng-container>
                                                            @for (childCat of childCategories.subcategories; track childCat) {
                                                                <li>
                                                                    <a
                                                                        [tabIndex]="0"
                                                                        role="button"
                                                                        [attr.aria-label]="childCat.name + ' ' + childCat.totalNumber"
                                                                        class="category"
                                                                        (click)="closeIfClickedTheSameLink(childCat.url)"
                                                                        [routerLink]="childCat.url">
                                                                        {{ childCat.name }}
                                                                        <span
                                                                            class="amount">{{ childCat.totalNumber }}</span>
                                                                    </a>
                                                                </li>
                                                            }
                                                        </ng-container>
                                                    </ul>

                                                </div>
                                            }
                                        } @else {
                                            <aimo-cx-navigation-ui [node]="childnode"></aimo-cx-navigation-ui>
                                        }
                                    </div>
                                }
                            </nav>
                        }
                    }
                }
            }
        }
    </div>
}
